import { useLocation } from "react-router-dom";
import STUtils from "../../assets/styles/utility.module.scss";
import { routes } from "../../router/Router";
import { CONTENT_TYPE, TAppContentType } from "../../types/TAppContentType";
import { getSubdomain } from "../../utils/getSubdomain";
import BottomNavigationBar from "../organisms/BottomNavigationBar";
import InfoArticleList from "../organisms/InfoArticleList";
import BaseHead from "../templates/BaseHead";
import { useEffect, useState } from "react";
import TApiResult from "../../types/api/TApiResult";
import { fetchCategories, TApiCategoriesResult } from "../../utils/api/fetchCategories";
import { categorySummary } from "../../types/categorySummary";

const InformationList: React.FC = () => {
  const query = new URLSearchParams(useLocation().search);
  const page = query.get("page") ? Number(query.get("page")) : 1;
  const list = query.get("list") ?? undefined;
  const category = query.get("category")
    ? Number(query.get("category"))
    : undefined;
  const title = query.get("title") ?? undefined;
  const categorySlug = query.get("category_slug") ?? undefined;
  const contentTypeIds: TAppContentType[] = [
    CONTENT_TYPE.information,
  ]
  const [categories, setCategories] = useState<categorySummary[]>([]);

  if(!list){
    contentTypeIds.push(CONTENT_TYPE.video);
  }

  useEffect(() => {
    const newCategories = [{ id: 0, name: "すべて", linkUrl: "" }];
    fetchCategories(true).then((res: TApiResult & TApiCategoriesResult) => {
      if (!res.isSuccess || !res.result) {
        return;
      }
      res.result.forEach((v, k) => {
        newCategories.push({
          id: v.id,
          name: v.name,
          linkUrl: v.slug
            ? `category_slug=${v.slug}`
            : `category=${v.id}`,
        });
      });
    });
    setCategories(newCategories);
  }, []);

  const subdomain = getSubdomain(window.location.hostname);
  return (
    <BaseHead
      title={routes.informations.title}
      login={true}
      subdomain={subdomain}
      hasBackground={true}
      hasNavigationBar={true}
      hasBackButton={true}
    >
      <section className={STUtils.container_large}>
        <InfoArticleList
          requestPage={page}
          requestCategory={category}
          requestTitle={title}
          requestCategorySlug={categorySlug}
          contentTypeIds={contentTypeIds}
          categories={categories}
          requestList={list}
        />
        <div>
          <BottomNavigationBar />
        </div>
      </section>
    </BaseHead>
  );
};

export default InformationList;
